import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectChannelProgramsListItems } from "../../../../../../redux/channel-program/selector";
import { channelPrograms } from "../../../../../../redux/channel-program/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";


const ShipXChannelPrograms = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectChannelProgramsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'Code', headerName: 'Channel Program Code', searchField: 'Code', sortable: true, filter: true, filterType: 'text' },
            { field: 'IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const fetchChannelPrograms = () => {
    dispatch(channelPrograms.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs/fetch`,
      entity: 'channelPrograms',
      jsonData: {
       "Context" :{},
       "Records" :
       [
        {}
       ]
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchChannelPrograms()
  }, [pageData, pageSize])

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add ShipX Channel Program</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add AccountType',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const handleEdit = (data: any) => {

    navigate(`${data?.GlobalChannelShipXProgramId}`)
  }

  const handleDelete = (data: any) => {
    dispatch(channelPrograms.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs/delete`,
      entity: 'channelPrograms',
      jsonData: {
        Cotext:{},
        Records: [
          {
            Id: data?.GlobalChannelShipXProgramId
          }
        ]
      }
    })).then(() => {
      dispatch(channelPrograms.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs/fetch`, entity: 'accountTypes', jsonData: {
          "Context" :{},
       "Records" :
       [
        {}
       ]
        }
      }))
    });
  }

  const handleReloadData = () => {
    fetchChannelPrograms();
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(channelPrograms.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs/fetch`,
      entity: 'channelPrograms',
      jsonData: {
         "Context" :{},
       "Records" :
       [
        {}
       ],
       Pagination:{
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }}
    }));
  }

  const handleSelect = (item: any, checked: any) => {
    console.log("Item", checked, item)
  }

  const handleSelectAll = (items: any[], checked: any) => {
    console.log("Items count", checked, items?.length)
    console.log('items', items)
  }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
          enableFilter={true} onSearch={handleSearch} onSelect={handleSelect} onSelectAll={handleSelectAll}
          onEdit={handleEdit} onDelete={handleDelete} paginationData={itemsData?.result?.pagination}
          additionButtons={additionButtons} headingName=" ShipX Channel Programs" />
      }
    </>
  );
};

export default ShipXChannelPrograms;


